module.exports = {
  backToMain: 'Вернуться на главный экран',
  print: 'Печать',
  savePDF: 'Сохранить как PDF',
  saveWord: 'Сохранить как WORD',
  saveExcel: 'Сохранить как EXCEL',
  email: 'Почта',
  fax: 'Факс',
  company: 'Название компании',
  emailAddress: 'Адрес электронной почты',
  cc: 'Копия (КК)',
  title: 'Тема письма',
  content: 'Содержание письма',
  localAgent: 'Локальный агент',
  destinationAgent: 'Агент порта отправления/назначения',
  designationAgent: 'Уполномоченный агент по грузу',
  customer: 'Клиент',
  bookingAgent: 'Агент по бронированию',
  motorcade: 'Автопарк',
  warehouse: 'Склад',
  send: 'Отправить',
  cancel: 'Отмена',
  tel: 'Телефон',
  ok: 'Подтвердить',
  faxCode: 'Код города',
  faxNo: 'Номер факса',
  faxExt: 'Добавочный номер',
  BlAddress: 'Адрес для сверки документов',
  ShippingCmp: 'Судоходная компания',
  NominatedAgent: 'Уполномоченный агент по грузу',
  PortAgency: 'Агент порта отправления/назначения',
  InvokeLocalMailClient: 'Использовать локальную почту'
}
